import styled, { css } from 'styled-components'
import { desktopBreakpoint, SolidButton, wideScreenBreakpoint } from 'react-components'
import { LAYOUT } from '../../../../constants/search-result-listing'

export const SidebarContainer = styled.aside<{ isLoading?: boolean }>`
    display: none;
    flex-direction: column;
    width: ${LAYOUT.SMALL_SIDEBAR_WIDTH}rem;
    flex-shrink: 0;
    height: fit-content;
    background-color: ${({ theme }) => theme.colors.white};
    border-radius: 12px;
    padding: 0.5rem 1rem;
    border: 1px solid #0000001a;
    position: relative;

    opacity: ${({ isLoading }) => (isLoading ? 0.6 : 1)};
    pointer-events: ${({ isLoading }) => (isLoading ? 'none' : 'auto')};

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        display: flex;
    }

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        width: ${LAYOUT.SIDEBAR_WIDTH}rem;
    }
`

export const FilterWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 1rem;
    margin-bottom: 1rem;
    border-bottom: 1px dotted #d5d5d5;

    &:last-child {
        border-bottom: none;
        margin-bottom: 0;
    }

    .filter-content {
        min-width: unset !important;
    }
`

export const StickyFooter = styled.div`
    position: sticky;
    z-index: 1;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: ${({ theme }) => theme.colors.white};
    padding: 1rem 0;
    border-top: 1px solid #0000001a;
    margin-top: auto;
`

export const SubmitButton = styled(SolidButton)<{ disabled?: boolean }>(
    ({ disabled, theme }) => css`
        width: 100%;
        display: flex;
        justify-content: center;
        padding: ${theme.spacing.xSmall} ${theme.spacing.medium};

        ${disabled &&
        css`
            pointer-events: none;
            cursor: not-allowed;
            opacity: 0.5;
        `};
    `,
)

export const ButtonText = styled.strong`
    text-align: center;
    font: ${({ theme }) => `${theme.typography.font.weight.bold} ${theme.typography.font.size.small} /
        ${theme.typography.font.size.xLarge} ${theme.typography.font.family.latoVerdana}`};
`
